<template>
  <v-app class="userpg" v-bind:class="{ xsOnly: $vuetify.breakpoint.xsOnly }">
    <v-content>
      <v-container fill-height >
        <v-layout align-center>
          <v-flex>
            <div class="h-hold text-xs-center">
            <a class="h-logohold" href="https://tryworktabs.com">
              <div class="h-logo"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 255.21 255.12"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="line" width="28.35" height="255.12"/><rect class="line" x="57.09" width="28.35" height="255.12"/><rect class="line" x="114.18" width="28.35" height="255.12"/><rect class="line" x="169.77" width="28.35" height="255.12"/><rect class="line" x="226.86" width="28.35" height="255.12"/></g></g></svg></div>
              <span class="logo-text">Worktabs</span>
            </a>
            <v-layout row v-if="error">
              <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-flex>
            </v-layout>
            <div class="entrycard mb-4">
              <h1 >Reset your password</h1>
                      <form @submit.prevent="onSendforgetPasswordEmail" v-if="!emailSent">
                            <v-text-field
                            name="email"
                            id="email"
                            placeholder=" "
                            v-model="email"
                            type="email"
                            label="Enter your email"
                            class="mb-4"
                            required>
                            </v-text-field>
                            <v-btn class="mt-4 mb-2" block large depressed color="primary" type="submit" :disabled="loading" :loading="loading">
                              <span class="body-2">Continue</span>
                              <span slot="loader" class="custom-loader">
                                <v-icon light>cached</v-icon>
                              </span>
                            </v-btn>
                      </form>
                      <div v-else>
                        <p class="pt-2 text-dark--text body">You're password email has been sent to  {{ email }}.</p>
                        <p class="pt-2 text-dark--text body">Please follow the link in the email to reset your password and then <router-link :to="{name: 'SignIn'}" class="mutedprimary--text">Sign In.</router-link></p>
                      </div>
              </div>
<p class="account-link pt-2 text-dark--text body bold text-xs-center">Don't have an account? <router-link :to="{name: 'SignUp'}" class="pr-2 mutedprimary--text">Sign Up</router-link></p>
              <p class="account-link pt-2 text-dark--text body bold text-xs-center">Learn more about how we use your data in our <a href="https://tryworktabs.com/terms/" target="blank" class="mutedprimary--text">privacy policy</a></p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  data () {
    return {
      email: '',
      emailSent: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    site () {
      return this.$store.getters.site
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  methods: {
    onSendforgetPasswordEmail () {
      const actionCodeSettings = {
        url: this.site.url
      }
      this.$store.commit('setLoading', true)
      this.$store.commit('clearError')
      firebase.auth().sendPasswordResetEmail(this.email, actionCodeSettings)
        .then(
          message => {
            this.$store.commit('setLoading', false)
            this.emailSent = true
          }
        )
        .catch(
          error => {
            this.$store.commit('setLoading', false)
            this.$store.commit('setError', error)
          }
        )
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
